import { Box, styled } from "@mui/material";

type StyledInvoiceListprops = {
  fullScreen: boolean;
};

export const StyledInvoiceList = styled(Box)<StyledInvoiceListprops>(
  ({ theme, fullScreen }) => ({
    display: "flex",
    flexDirection: "column",
    paddingInline: "1rem",
    ".list": {
      maxHeight: "40rem",
      overflowY: fullScreen ? "scroll" : "none",
      "& > *:nth-child(odd)": {
        background: theme.contrast.lighter,
      },
    },
    [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      height: "80vh",
    },
  })
);
